import * as React from "react";
function SvgUpIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9998 5L5.99976 1L0.999756 5" stroke="black" strokeLinecap="round" />
        </svg>;
}
export default SvgUpIcon;